import React from 'react';
import PropTypes from 'prop-types';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function PermissionsErrorPage({ message = 'No user permissions found' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        width: '100%',
      }}
    >
      <Paper
        data-cy="permissions-error-page"
        elevation={3}
        sx={{
          p: 5,
          maxWidth: '600px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 60 }} />
        <Typography variant="h4" color="error" gutterBottom>
          Permissions Error
        </Typography>
        <Typography variant="body1" paragraph>
          Sorry, you can&apos;t use this application until permissions have been configured.
        </Typography>
        <Typography variant="body1" paragraph>
          Error details: {message}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          Please contact IT for assistance.
        </Typography>
      </Paper>
    </Box>
  );
}

PermissionsErrorPage.propTypes = {
  message: PropTypes.string,
};

export default React.memo(PermissionsErrorPage);
